import { useEffect, useState } from "react";
import { Column, DataTableClient } from "components/common/DataTable";
import { GridForm } from "components/common/ListForm";
import { useHandleParamUrl } from "hooks/useHandleParamUrl";
import { classNames } from "primereact/utils";
import { MyCalendar } from "components/common/MyCalendar";
import { useListCustomerDetailWithState } from "modules/partner/service";
import { Helper } from "utils/helper";
import { Splitter } from "primereact/splitter";
import { FilterMatchMode } from "primereact/api";
import { useListBaoCaoLoiNhuanTheoXe } from "modules/Debit/service";
import { useListIncomeExpenseWithState } from "modules/categories/service";
import { DataTable } from "components/uiCore";

// ✅ Component Header lọc dữ liệu
const Header = ({ _setParamsPaginator, _paramsPaginator }: any) => {
  const [filter, setFilter] = useState({
    name: "",
    customerDetailId: "",
    fromDate: Helper.getFirstDayOfCurrentMonthYMD(),
    toDate: Helper.getLastDayOfCurrentMonthYMD(),
  });
  useEffect(() => {
    // Mỗi khi filter thay đổi => cập nhật params
    _setParamsPaginator((prev: any) => ({
      ...prev,
      keyword: filter.name,
      customerDetailId: filter.customerDetailId,
      fromDate: filter.fromDate,
      toDate: filter.toDate,
      // Invoice:1
    }));
  }, [filter]);
  return (
    <GridForm
      paramsPaginator={_paramsPaginator}
      setParamsPaginator={_setParamsPaginator}
      filter={filter}
      setFilter={setFilter}
      className="lg:col-9"
    >
      <div className="col-2">
        <MyCalendar
          dateFormat="dd/mm/yy"
          value={filter.fromDate}
          onChange={(e: any) => setFilter({ ...filter, fromDate: e })}
          className={classNames("w-full", "p-inputtext", "input-sm")}
        />
      </div>
      <div className="col-2">
        <MyCalendar
          dateFormat="dd/mm/yy"
          value={filter.toDate}
          onChange={(e: any) => setFilter({ ...filter, toDate: e })}
          className={classNames("w-full", "p-inputtext", "input-sm")}
        />
      </div>
    </GridForm>
  );
};

export default function ListLoiNhuanTheoXe() {
  const { handleParamUrl } = useHandleParamUrl();
  const [displayData, setDisplayData] = useState<any[]>([]);
  const { data: customers } = useListCustomerDetailWithState({status: 1});
  const [filters, setFilters] = useState({
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
          });
  const [paramsPaginator, setParamsPaginator] = useState({
    pageNum: 1,
    pageSize: 20,
    first: 0,
    render: false,
    keyword: "",
  });
  const { data, loading, error, refresh } = useListBaoCaoLoiNhuanTheoXe({
    params: paramsPaginator,
    debounce: 500,
  });
  const { data: DMExpense } = useListIncomeExpenseWithState({}); 
  const safeReduce = (arr: any[], field: string) =>
  arr?.reduce((acc: number, curr: any) => acc + (curr?.[field] || 0), 0) || 0;

  // ✅ Client-side pagination
  useEffect(() => {
    if (!data) return;
    handleParamUrl(paramsPaginator);
      // 16: phí sửa chữa
      // 17: phí dầu DO
      // 18: Cước đường bộ
      // 19: phí khác
      // 20: phí lãi vay
      // 22 : trích lương lái xe
      // 34: trích BHXH
      // 35: phí gửi xe
      // 38: phí đi đường lái xe
    const allCost = (data[0]?.data?.debit_theoxe || []).reduce(
      (total: number, row: any) => {
        const totalCost =
          (row.total_price || 0) +
          (row.total_driver_fee || 0);
        return total + totalCost;
      },
      0
    );
    let baocaoloinhuan = (data[0]?.data?.debit_theoxe || []).map((row: any) => {
      const totalCost = row.total_price + row.total_driver_fee;
      const listPhi =(data[0]?.data?.chi_theoxe || []).filter((item: any) => item.vehicle_id === row.id);
      const khauHaoXe =(data[0]?.data?.khauhao_theoxe || []).find((item: any) => item.id === row.id);
      return {
        ...row,
        totalCost,
        phiDau :listPhi?.reduce((sum: number, p: any) => p.income_expense_category_id === 17 ? sum + (p.amount ? parseFloat(p.amount.toString()) : 0) : sum, 0) || 0,
        cuocDuongBo : listPhi?.reduce((sum: number, p: any) => p.income_expense_category_id === 18 ? sum + (p.amount ? parseFloat(p.amount.toString()) : 0) : sum, 0) || 0,
        phiSuaChua : listPhi?.reduce((sum: number, p: any) => p.income_expense_category_id === 16 ? sum + (p.amount ? parseFloat(p.amount.toString()) : 0) : sum, 0) || 0,
        phiKhac : listPhi?.reduce((sum: number, p: any) => p.income_expense_category_id === 19 ? sum + (p.amount ? parseFloat(p.amount.toString()) : 0) : sum, 0) || 0,
        laiVay : listPhi?.reduce((sum: number, p: any) => p.income_expense_category_id === 20 ? sum + (p.amount ? parseFloat(p.amount.toString()) : 0) : sum, 0) || 0,
        trichLuongLaiXe : listPhi?.reduce((sum: number, p: any) => p.income_expense_category_id === 22 ? sum + (p.amount ? parseFloat(p.amount.toString()) : 0) : sum, 0) || 0,
        trichBHXH : listPhi?.reduce((sum: number, p: any) => p.income_expense_category_id === 34 ? sum + (p.amount ? parseFloat(p.amount.toString()) : 0) : sum, 0) || 0,
        phiGuiXe : listPhi?.reduce((sum: number, p: any) => p.income_expense_category_id === 35 ? sum + (p.amount ? parseFloat(p.amount.toString()) : 0) : sum, 0) || 0,
        phiDiDuongLaiXe : listPhi?.reduce((sum: number, p: any) => p.income_expense_category_id === 38 ? sum + (p.amount ? parseFloat(p.amount.toString()) : 0) : sum, 0) || 0,
        tongChiPhi: listPhi?.reduce((sum: number, p: any) => sum + (p.amount ? parseFloat(p.amount.toString()) : 0), 0) || 0, 
        khauHao: khauHaoXe?.total_monthly_depreciation,
        loiNhuan: totalCost - (listPhi?.reduce((sum: number, p: any) => sum + (p.amount ? parseFloat(p.amount.toString()) : 0), 0) || 0),
        tySuatLoiNhuan: ( ((totalCost - (listPhi?.reduce( (sum: number, p: any) => sum + (p.amount ? parseFloat(p.amount.toString()) : 0), 0 ) || 0) ) / allCost) * 100 ).toFixed(1),
        loiNhuanChuaKH: totalCost - (listPhi?.reduce((sum: number, p: any) => sum + (p.amount ? parseFloat(p.amount.toString()) : 0), 0) || 0),
      };
    });
    const loinhuanxengoai = (data[1]?.data || []).map((row: any) => {
      return {
        ...row,
        number_code: "Thu nhập gọi xe ngoài",
        totalCost: row.total_price + row.total_driver_fee,
        phiDau : row.total_purchase_price || 0,
        tongChiPhi: row.total_purchase_price || 0,
        loiNhuan: (row.total_price + row.total_driver_fee) - (row.total_purchase_price || 0),
      };
    });
  
    
    const doanhSo =
      safeReduce(data?.[3]?.data?.loinhuan_banhang, "total_price") +
      safeReduce(data?.[3]?.data?.loinhuan_com, "total_price_com") +
      safeReduce(data?.[3]?.data?.loinhuan_phikhac, "total_price") +
      safeReduce(data?.[3]?.data?.loinhuan_thu, "total_amount");

    const chiPhi =
      safeReduce(data?.[3]?.data?.loinhuan_muahang, "total_purchase_price") +
      safeReduce(data?.[3]?.data?.loinhuan_com, "total_purchase_com") +
      safeReduce(data?.[3]?.data?.loinhuan_phikhac, "total_purchase_price") +
      safeReduce(data?.[3]?.data?.loinhuan_chi, "total_amount");

    const khauhaochung =
      safeReduce(data?.[3]?.data?.khauhao_chung, "total_monthly_depreciation");

    const loinhuandoanhthukhac = [
      {
        number_code: "Thu nhập thu khác",
        totalCost: doanhSo || 0,
        phiDau: chiPhi || 0,
        tongChiPhi: chiPhi || 0,
        khauHao:khauhaochung || 0,
        loiNhuan: (doanhSo || 0) - (chiPhi || 0),
      },
    ];
    const loinhuanhaiquan = [
      {
        number_code: "Thu nhập từ khai quan",
        totalCost: data[2]?.data.reduce((acc: number, curr: any) => acc + curr.total_price, 0), // doanh số
        phiDau: data[2]?.data.reduce((acc: number, curr: any) => acc + curr.total_purchase_price, 0) || 0 ,// phí mua hàng
        tongChiPhi: data[2]?.data.reduce((acc: number, curr: any) => acc + curr.total_purchase_price, 0) || 0,
        loiNhuan: (data[2]?.data.reduce((acc: number, curr: any) => acc + curr.total_price, 0)) - 
        (data[2]?.data.reduce((acc: number, curr: any) => acc + curr.total_purchase_price, 0) || 0),
      }
    ]
    baocaoloinhuan.push(...loinhuanxengoai);
    baocaoloinhuan.push(...loinhuandoanhthukhac);
    baocaoloinhuan.push(...loinhuanhaiquan);
    setDisplayData(baocaoloinhuan);
  }, [data, paramsPaginator, customers]);
    const getSumColumn = (field: string) => {
        const filtered = (displayData ?? []).filter((item: any) => {
            return Object.entries(filters).every(([key, f]: [string, any]) => {
                const value = f?.value?.toString().toLowerCase() ?? "";
                if (!value) return true;
                const cell = item[key]?.toString().toLowerCase() ?? "";
                return cell.includes(value);
            });
        });

        const sum = filtered.reduce((acc: number, item: any) => {
            const raw = item[field]?.toString() ?? "0";
            const val = parseFloat(raw.replace(/[^0-9.-]/g, "")) || 0; // giữ lại dấu âm
            return acc + val;
        }, 0);

        return Helper.formatCurrency(sum.toString());
    };
  return (
    <>
      <div className="card">
        <Header
          _paramsPaginator={paramsPaginator}
          _setParamsPaginator={setParamsPaginator}
        />
        <div style={{ height: "calc(100vh - 8rem)" }}>
          <Splitter style={{ height: "100%", width: "100%" }}>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <DataTable
                rowHover
                value={displayData}
                currentPageReportTemplate="Tổng số: {totalRecords} bản ghi"
                loading={loading}
                dataKey="id"
                title="Tài khoản"
                filterDisplay="row"
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                className={classNames("Custom-DataTableClient")}
                scrollable
                showGridlines
                scrollHeight="flex"
                style={{ flex: 1 }}
                tableStyle={{ minWidth: "2000px" }} // ép bảng rộng hơn để có scroll ngang
              >
                <Column
                  field="number_code"
                  header="Tên Xe"
                  filter
                  frozen alignFrozen="left" 
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  field="totalCost"
                  header="Doanh số"
                  body={(rowData: any) =>
                    Helper.formatCurrency(rowData?.totalCost?.toString())
                  }
                  footer={getSumColumn("totalCost")}
                  footerStyle={{ fontWeight: "bold" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  field="file_number"
                  header="Phí dầu/cước mua"
                  body={(rowData: any) => {
                    const phiDau = rowData.phiDau || 0;
                    return Helper.formatCurrency(phiDau.toString());
                  }}
                  footer={getSumColumn("phiDau")}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  field="bill"
                  header="Cước đường bộ"
                  body={(rowData: any) => {
                    const cuocDuongBo = rowData.cuocDuongBo || 0;
                    return Helper.formatCurrency(cuocDuongBo.toString());
                  }}
                  footer={getSumColumn("cuocDuongBo")}
                  footerStyle={{ fontWeight: "bold" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  field="declaration"
                  header="Phí sửa chữa"
                  body={(rowData: any) => {
                    const phiSuaChua = rowData.phiSuaChua || 0;
                    return Helper.formatCurrency(phiSuaChua.toString());
                  }}
                  footer={getSumColumn("phiSuaChua")}
                  footerStyle={{ fontWeight: "bold" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  header="Phí khác"
                  body={(rowData: any) => {
                    const phiKhac = rowData.phiKhac || 0;
                    return Helper.formatCurrency(phiKhac.toString());
                  }}
                  footer={getSumColumn("phiKhac")}
                  footerStyle={{ fontWeight: "bold" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  header="Lãi vay"
                  body={(rowData: any) => {
                    const laiVay = rowData.laiVay || 0;
                    return Helper.formatCurrency(laiVay.toString());
                  }}
                  footer={getSumColumn("laiVay")}
                  footerStyle={{ fontWeight: "bold" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  header="Lương lái xe"
                  body={(rowData: any) => {
                    const trichLuongLaiXe = rowData.trichLuongLaiXe || 0;
                    return Helper.formatCurrency(trichLuongLaiXe.toString());
                  }}
                  footer={getSumColumn("trichLuongLaiXe")}
                  footerStyle={{ fontWeight: "bold" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  body={(rowData: any) => {
                    const trichBHXH = rowData.trichBHXH || 0;
                    return Helper.formatCurrency(trichBHXH.toString());
                  }}
                  footer={getSumColumn("trichBHXH")}
                  footerStyle={{ fontWeight: "bold" }}
                  header="Phí BHXH"
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="listEmployee"
                  header="Phí gửi xe"
                  body={(rowData: any) => {
                    const phiGuiXe = rowData.phiGuiXe || 0;
                    return Helper.formatCurrency(phiGuiXe.toString());
                  }}
                  footer={getSumColumn("phiGuiXe")}
                  footerStyle={{ fontWeight: "bold" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  field="listEmployee"
                  header="Phí đi đường của lái xe"
                  body={(rowData: any) => {
                    const phiDiDuongLaiXe = rowData.phiDiDuongLaiXe || 0;
                    return Helper.formatCurrency(phiDiDuongLaiXe.toString());
                  }}
                  footer={getSumColumn("phiDiDuongLaiXe")}
                  footerStyle={{ fontWeight: "bold" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  field="listEmployee"
                  header="Tổng chi phí"
                  body={(rowData: any) => {
                    const tongChiPhi = rowData.tongChiPhi || 0;
                    return Helper.formatCurrency(tongChiPhi.toString());
                  }}
                  footer={getSumColumn("tongChiPhi")}
                  footerStyle={{ fontWeight: "bold",textAlign: "right" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  header="Khấu hao/chi phí phân bổ"
                   body={(rowData: any) => {
                    const khauHao = rowData.khauHao || 0;
                    return Helper.formatCurrency(khauHao.toString());
                  }}
                   footer={getSumColumn("khauHao")}
                   footerStyle={{ fontWeight: "bold",textAlign: "right" }}
                   style={{ textAlign: "right" }}
                   filter
                   showFilterMenu={false}
                   filterMatchMode="contains"
                />
                <Column
                  field="loiNhuan"
                  header="Lợi nhuận"
                  body={(rowData: any) => {
                    const loiNhuan = rowData.loiNhuan || 0;
                    return Helper.formatCurrency(loiNhuan.toString());
                  }}
                  footer={getSumColumn("loiNhuan")}
                  footerStyle={{ fontWeight: "bold" }}
                  style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  header="Tỷ suất lợi nhuận"
                   body={(rowData: any) => {
                    return rowData.tySuatLoiNhuan
                  }}
                   style={{ textAlign: "center" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  header="Lợi nhuận chưa tính khấu hao"
                  body={(rowData: any) => {
                    const loiNhuanChuaKH = rowData.loiNhuanChuaKH || 0;
                    return Helper.formatCurrency(loiNhuanChuaKH.toString());
                  }}
                  footer={getSumColumn("loiNhuanChuaKH")}
                  footerStyle={{ fontWeight: "bold",textAlign: "right" }}
                   style={{ textAlign: "right" }}
                  filter
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
              </DataTable>
            </div>
          </Splitter>
        </div>
      </div>
    </>
  );
}
